/* Roo Roo — shoppable video carousel.
   Circular scroll loop, centre focus, one clip playing at a time, and a
   fullscreen player with sound. */
(function () {
  function isSafe(url) {
    if (!url) return false;
    var check = window.Roo && window.Roo.isSafeUrl;
    return typeof check === "function" ? check(url) : true;
  }

  function makeClone(card) {
    var clone = card.cloneNode(true);
    clone.setAttribute("data-rsr-clone", "");
    clone.setAttribute("aria-hidden", "true");
    clone.classList.remove("is-active", "is-playing");
    Array.prototype.forEach.call(clone.querySelectorAll("a, button"), function (el) {
      el.setAttribute("tabindex", "-1");
    });
    Array.prototype.forEach.call(clone.querySelectorAll("video"), function (v) { v.remove(); });
    return clone;
  }

  function appendSet(target, originals) {
    originals.forEach(function (card) { target.appendChild(makeClone(card)); });
  }

  function buildLoop(root, track) {
    var originals = Array.prototype.slice.call(
      track.querySelectorAll("[data-rsr-card]:not([data-rsr-clone])")
    );
    var count = originals.length;
    if (count < 2) return null;

    root.classList.add("rsr--loop");

    /* One set each side first, so the distance between a card and its twin can
       be measured directly — that distance IS the set width, gaps included.
       (Matching cards by getAttribute('data-rsr-card') does not work: it is a
       valueless attribute, so every card returns "" and the nearest neighbour
       wins, making a "set" exactly one card wide.) */
    var head = document.createDocumentFragment();
    var tail = document.createDocumentFragment();
    appendSet(head, originals);
    appendSet(tail, originals);
    track.insertBefore(head, track.firstChild);
    track.appendChild(tail);

    var lead = originals[0];
    var all = Array.prototype.slice.call(track.querySelectorAll("[data-rsr-card]"));
    var twin = all[all.indexOf(lead) + count];
    if (!twin) return null;

    var setWidth = twin.offsetLeft - lead.offsetLeft;
    if (setWidth <= 0) return null;

    /* Runway: a single flick can travel well over a screen, and running out of
       cards mid-flick is what makes a loop feel broken. Give at least 2.5
       screens of clones on each side. */
    var side = 1;
    while (side * setWidth < track.clientWidth * 2.5 && side < 4) {
      var moreHead = document.createDocumentFragment();
      var moreTail = document.createDocumentFragment();
      appendSet(moreHead, originals);
      appendSet(moreTail, originals);
      track.insertBefore(moreHead, track.firstChild);
      track.appendChild(moreTail);
      side++;
    }

    track.scrollLeft = lead.offsetLeft - (track.clientWidth - lead.offsetWidth) / 2;

    return {
      setWidth: setWidth,
      home: track.scrollLeft,
      count: count,
      originals: originals
    };
  }

  function init(root) {
    if (!root || root.dataset.rsrReady === "true") return;
    root.dataset.rsrReady = "true";

    var track = root.querySelector("[data-rsr-track]");
    if (!track) return;

    var loop = buildLoop(root, track);
    var cards = Array.prototype.slice.call(track.querySelectorAll("[data-rsr-card]"));
    if (!cards.length) return;

    var prevBtn = root.querySelector("[data-rsr-prev]");
    var nextBtn = root.querySelector("[data-rsr-next]");
    var modal = root.querySelector("[data-rsr-modal]");
    var player = modal && modal.querySelector("[data-rsr-player]");
    var buy = modal && modal.querySelector("[data-rsr-buy]");

    var inView = true;
    var modalOpen = false;
    var dragging = false;
    var settleTimer = 0;
    var activeIdx = -1;
    var mounted = [];

    function metrics() {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return { step: cards[0].offsetWidth + gap, base: cards[0].offsetLeft + cards[0].offsetWidth / 2 };
    }
    var m = metrics();

    /* O(1): the cards are all the same width, so the centred one is arithmetic
       rather than a rect scan of every card on every frame. */
    function centredIndex() {
      if (!(m.step > 0)) return activeIdx < 0 ? 0 : activeIdx;
      var i = Math.round((track.scrollLeft + track.clientWidth / 2 - m.base) / m.step);
      if (i < 0) i = 0;
      if (i > cards.length - 1) i = cards.length - 1;
      return i;
    }

    function mount(card) {
      var slot = card.querySelector("[data-rsr-src]");
      if (!slot) return null;
      var existing = slot.querySelector("video");
      if (existing) return existing;
      var src = slot.getAttribute("data-rsr-src");
      if (!isSafe(src)) return null;

      var video = document.createElement("video");
      video.className = "rsr-video";
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.setAttribute("preload", "metadata");
      var poster = slot.getAttribute("data-rsr-poster");
      if (poster && isSafe(poster)) video.poster = poster;
      var source = document.createElement("source");
      source.src = src;
      source.type = "video/mp4";
      video.appendChild(source);
      video.addEventListener("playing", function () { card.classList.add("is-playing"); });
      video.addEventListener("pause", function () { card.classList.remove("is-playing"); });
      video.addEventListener("error", function () { card.classList.add("is-poster-only"); });
      slot.appendChild(video);

      mounted.push(card);
      trim();
      return video;
    }

    /* Clones are real cards on screen, so they play their own clip rather than
       showing a frozen poster. Cap how many stay in memory. */
    function trim() {
      while (mounted.length > 4) {
        var old = mounted.shift();
        if (old === cards[activeIdx]) { mounted.push(old); return; }
        var v = old.querySelector("video");
        if (v) { v.pause(); v.remove(); }
        old.classList.remove("is-playing");
      }
    }

    function pauseAll(except) {
      mounted.forEach(function (card) {
        var video = card.querySelector("video");
        if (video && video !== except) video.pause();
      });
    }

    function play(card) {
      var video = mount(card);
      if (!video) return;
      if (video.preload !== "auto") video.preload = "auto";
      var attempt = video.play();
      if (attempt && typeof attempt.catch === "function") attempt.catch(function () {});
    }

    function updateFocus(force) {
      var i = centredIndex();
      if (i === activeIdx && !force) return;

      if (activeIdx >= 0 && cards[activeIdx]) cards[activeIdx].classList.remove("is-active");
      activeIdx = i;
      cards[i].classList.add("is-active");

      if (inView && !modalOpen) {
        pauseAll(cards[i].querySelector("video"));
        play(cards[i]);
      } else {
        pauseAll(null);
      }
    }

    var raf = 0;
    function scheduleFocus(force) {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; updateFocus(force); });
    }

    /* Shifting scrollLeft mid-flick kills momentum on iOS, so the wrap waits
       until the scroll has settled. The edge guard is the exception: it only
       fires if a very long flick is about to run out of cards. */
    function shift(by) {
      var prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = "none";
      track.scrollLeft = track.scrollLeft + by;
      void track.offsetWidth;
      track.style.scrollSnapType = prevSnap;
      m = metrics();
      activeIdx = -1;
    }

    function silentWrap() {
      if (!loop || dragging || modalOpen) return;
      var x = track.scrollLeft;
      var w = loop.setWidth;
      if (x < loop.home - w * 0.5) shift(w);
      else if (x >= loop.home + w * 0.5) shift(-w);
    }

    function edgeGuard() {
      if (!loop) return;
      var margin = track.clientWidth * 0.5;
      var limit = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft < margin) shift(loop.setWidth);
      else if (track.scrollLeft > limit - margin) shift(-loop.setWidth);
    }

    function settle() {
      if (dragging) return;
      silentWrap();
      scheduleFocus(true);
    }

    function onScroll() {
      edgeGuard();
      scheduleFocus();
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(settle, 120);
    }

    function centreCard(card) {
      if (!card) return;
      var rect = card.getBoundingClientRect();
      var trackRect = track.getBoundingClientRect();
      var delta = rect.left + rect.width / 2 - (trackRect.left + trackRect.width / 2);
      track.scrollBy({ left: delta, behavior: "smooth" });
    }

    function step(dir) {
      var i = (activeIdx < 0 ? centredIndex() : activeIdx) + dir;
      if (i < 0) i = 0;
      if (i > cards.length - 1) i = cards.length - 1;
      centreCard(cards[i]);
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(settle, 480);
    }

    function fillBuy(card) {
      if (!buy) return;
      var info = card.querySelector("[data-rsr-info]");
      var href = info && info.getAttribute("data-rsr-buy-href");
      if (!href) { buy.hidden = true; return; }
      buy.href = href;
      buy.hidden = false;
      var img = buy.querySelector("[data-rsr-buy-img]");
      var image = info.getAttribute("data-rsr-buy-image");
      if (img) {
        if (image) { img.src = image; img.alt = info.getAttribute("data-rsr-buy-title") || ""; img.hidden = false; }
        else img.hidden = true;
      }
      var name = buy.querySelector("[data-rsr-buy-name]");
      if (name) name.textContent = info.getAttribute("data-rsr-buy-title") || "";
      var amount = buy.querySelector("[data-rsr-buy-amount]");
      if (amount) amount.textContent = info.getAttribute("data-rsr-buy-price") || "";
      var was = buy.querySelector("[data-rsr-buy-was]");
      if (was) {
        var compare = info.getAttribute("data-rsr-buy-compare");
        if (compare) { was.textContent = compare; was.hidden = false; }
        else was.hidden = true;
      }
    }

    function openModal(card) {
      if (!modal || !player) return;
      var media = card.querySelector("[data-rsr-media]");
      var full = media && media.getAttribute("data-rsr-full");
      if (!isSafe(full)) return;
      pauseAll(null);
      modalOpen = true;
      player.pause();
      player.removeAttribute("src");
      player.load();
      player.src = full;
      player.muted = false;
      player.loop = true;
      fillBuy(card);
      modal.hidden = false;
      modal.classList.add("is-open");
      document.documentElement.classList.add("rsr-locked");
      var attempt = player.play();
      if (attempt && typeof attempt.catch === "function") attempt.catch(function () {});
    }

    function closeModal() {
      if (!modal || !modalOpen) return;
      modalOpen = false;
      if (player) { player.pause(); player.removeAttribute("src"); player.load(); }
      modal.classList.remove("is-open");
      modal.hidden = true;
      document.documentElement.classList.remove("rsr-locked");
      scheduleFocus(true);
    }

    function setDragging(state) {
      dragging = state;
      root.classList.toggle("is-dragging", state);
      if (!state) {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(settle, 140);
      }
    }

    track.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      setDragging(true);
    }, { passive: true });
    window.addEventListener("pointerup", function () { if (dragging) setDragging(false); }, { passive: true });
    window.addEventListener("pointercancel", function () { if (dragging) setDragging(false); }, { passive: true });
    track.addEventListener("touchstart", function () { setDragging(true); }, { passive: true });
    window.addEventListener("touchend", function () { if (dragging) setDragging(false); }, { passive: true });

    track.addEventListener("click", function (e) {
      var media = e.target.closest && e.target.closest("[data-rsr-media]");
      if (!media) return;
      var card = media.closest("[data-rsr-card]");
      if (!card) return;
      if (media.getAttribute("data-rsr-full")) { openModal(card); return; }
      var info = card.querySelector("[data-rsr-info]");
      var href = info && info.getAttribute("href");
      if (href && isSafe(href)) window.location.href = href;
    });

    if (prevBtn) prevBtn.addEventListener("click", function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { step(1); });

    if (modal) {
      Array.prototype.forEach.call(modal.querySelectorAll("[data-rsr-close]"), function (el) {
        el.addEventListener("click", closeModal);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && modalOpen) closeModal();
      });
    }

    track.addEventListener("scroll", onScroll, { passive: true });
    if ("onscrollend" in window) {
      track.addEventListener("scrollend", settle, { passive: true });
    }

    window.addEventListener("resize", function () {
      m = metrics();
      if (loop) {
        var lead = loop.originals[0];
        loop.setWidth = m.step * loop.count;
        loop.home = lead.offsetLeft - (track.clientWidth - lead.offsetWidth) / 2;
      }
      scheduleFocus(true);
    }, { passive: true });

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { inView = entry.isIntersecting; });
        scheduleFocus(true);
      }, { threshold: 0.2 }).observe(root);
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) pauseAll(null);
      else scheduleFocus(true);
    });

    requestAnimationFrame(function () { updateFocus(true); });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-rsr]"), init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
